import React from 'react'
import TextInput, { TextInputProps } from './text-input.component'

export const HourInput = ({ type, ...rest }: TextInputProps) => {
    return <TextInput type="time" {...rest} />
}
